const v = "4.8.0";
const meta = {
  g: "LottieFiles AE ",
  a: "",
  k: "",
  d: "",
  tc: ""
};
const fr = 29.9700012207031;
const ip = 0;
const op = 60.0000024438501;
const w = 168;
const h = 80;
const nm = "outro_right_eff";
const ddd = 0;
const assets = [];
const layers = [
  {
    ddd: 0,
    ind: 1,
    ty: 1,
    nm: "Null 1",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 0,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          84,
          35,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          50,
          50,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    sw: 100,
    sh: 100,
    sc: "#ffffff",
    ip: 0,
    op: 60.0000024438501,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 2,
    ty: 4,
    nm: "모양 레이어 7",
    parent: 1,
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 40,
            s: [
              100
            ]
          },
          {
            t: 47.0000019143492,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          49.75,
          57.25,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          0,
          0,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.092,
                0.092,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 32,
            s: [
              16,
              16,
              100
            ]
          },
          {
            t: 47.0000019143492,
            s: [
              35,
              35,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            d: 1,
            ty: "el",
            s: {
              a: 0,
              k: [
                160,
                160
              ],
              ix: 2
            },
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 3
            },
            nm: "타원 패스 1",
            mn: "ADBE Vector Shape - Ellipse",
            hd: false
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                1,
                1,
                1,
                1
              ],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 1,
              k: [
                {
                  i: {
                    x: [
                      0.667
                    ],
                    y: [
                      1
                    ]
                  },
                  o: {
                    x: [
                      0.333
                    ],
                    y: [
                      0
                    ]
                  },
                  t: 32,
                  s: [
                    20
                  ]
                },
                {
                  t: 40.0000016292334,
                  s: [
                    32
                  ]
                }
              ],
              ix: 5
            },
            lc: 1,
            lj: 1,
            ml: 4,
            bm: 0,
            nm: "선 1",
            mn: "ADBE Vector Graphic - Stroke",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "타원 1",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 32.0000013033867,
    op: 47.0000019143492,
    st: 6.00000024438501,
    bm: 0
  },
  {
    ddd: 0,
    ind: 3,
    ty: 4,
    nm: "star 윤곽선 14",
    parent: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          91.527,
          29.523,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          60.121,
          23.326,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 34.983,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 39.001,
            s: [
              104.997,
              104.997,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 42.976,
            s: [
              84.997,
              84.997,
              100
            ]
          },
          {
            t: 46.9705019131477,
            s: [
              0,
              0,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -1.1,
                    0
                  ],
                  [
                    0,
                    1.076
                  ],
                  [
                    1.1,
                    0
                  ],
                  [
                    0,
                    -1.077
                  ]
                ],
                o: [
                  [
                    1.1,
                    0
                  ],
                  [
                    0,
                    -1.077
                  ],
                  [
                    -1.1,
                    0
                  ],
                  [
                    0,
                    1.076
                  ]
                ],
                v: [
                  [
                    0,
                    1.949
                  ],
                  [
                    1.992,
                    1e-3
                  ],
                  [
                    0,
                    -1.949
                  ],
                  [
                    -1.992,
                    1e-3
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "mm",
            mm: 4,
            nm: "패스 병합 1",
            mn: "ADBE Vector Filter - Merge",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                1,
                0.870588235294,
                0.011764705882,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "칠 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                60.121,
                23.326
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "그룹 1",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 34.9830014248868,
    op: 47.4705019335131,
    st: 34.9830014248868,
    bm: 0
  },
  {
    ddd: 0,
    ind: 4,
    ty: 4,
    nm: "star 윤곽선 13",
    parent: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          -19.723,
          37.398,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          60.121,
          23.326,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 34.983,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 39.001,
            s: [
              104.997,
              104.997,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 42.976,
            s: [
              84.997,
              84.997,
              100
            ]
          },
          {
            t: 46.9705019131477,
            s: [
              0,
              0,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -1.1,
                    0
                  ],
                  [
                    0,
                    1.076
                  ],
                  [
                    1.1,
                    0
                  ],
                  [
                    0,
                    -1.077
                  ]
                ],
                o: [
                  [
                    1.1,
                    0
                  ],
                  [
                    0,
                    -1.077
                  ],
                  [
                    -1.1,
                    0
                  ],
                  [
                    0,
                    1.076
                  ]
                ],
                v: [
                  [
                    0,
                    1.949
                  ],
                  [
                    1.992,
                    1e-3
                  ],
                  [
                    0,
                    -1.949
                  ],
                  [
                    -1.992,
                    1e-3
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "mm",
            mm: 4,
            nm: "패스 병합 1",
            mn: "ADBE Vector Filter - Merge",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                1,
                1,
                1,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "칠 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                60.121,
                23.326
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "그룹 1",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 34.9830014248868,
    op: 47.4705019335131,
    st: 34.9830014248868,
    bm: 0
  },
  {
    ddd: 0,
    ind: 5,
    ty: 4,
    nm: "star 윤곽선 12",
    parent: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          -7.787,
          30.128,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          11.056,
          11.056,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 34.98,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 38.976,
            s: [
              62.997,
              62.997,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 42.973,
            s: [
              42.997,
              42.997,
              100
            ]
          },
          {
            t: 46.9675019130255,
            s: [
              0,
              0,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -0.143,
                    0.257
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    -1.115
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.257,
                    -0.143
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1.115,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.143,
                    -0.257
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    1.116
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.257,
                    0.143
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1.114,
                    0.6
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    -1.115
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.143,
                    0.257
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1.115,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.257,
                    0.143
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    1.116
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.143,
                    -0.257
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1.114,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.257,
                    -0.143
                  ]
                ],
                v: [
                  [
                    -4.117,
                    -4.746
                  ],
                  [
                    -1.401,
                    -9.691
                  ],
                  [
                    1.4,
                    -9.691
                  ],
                  [
                    4.116,
                    -4.746
                  ],
                  [
                    4.745,
                    -4.116
                  ],
                  [
                    9.691,
                    -1.401
                  ],
                  [
                    9.691,
                    1.401
                  ],
                  [
                    4.745,
                    4.117
                  ],
                  [
                    4.116,
                    4.746
                  ],
                  [
                    1.4,
                    9.69
                  ],
                  [
                    -1.401,
                    9.69
                  ],
                  [
                    -4.117,
                    4.746
                  ],
                  [
                    -4.746,
                    4.117
                  ],
                  [
                    -9.692,
                    1.401
                  ],
                  [
                    -9.692,
                    -1.401
                  ],
                  [
                    -4.746,
                    -4.116
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "mm",
            mm: 4,
            nm: "패스 병합 1",
            mn: "ADBE Vector Filter - Merge",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                1,
                0.870588235294,
                0.011764705882,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "칠 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                11.056,
                11.057
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "그룹 2",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 34.9800014247646,
    op: 47.4675019333909,
    st: 34.9800014247646,
    bm: 0
  },
  {
    ddd: 0,
    ind: 6,
    ty: 4,
    nm: "star 윤곽선 11",
    parent: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          103.463,
          43.712,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          11.056,
          11.056,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 34.98,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 38.976,
            s: [
              62.997,
              62.997,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 42.973,
            s: [
              42.997,
              42.997,
              100
            ]
          },
          {
            t: 46.9675019130255,
            s: [
              0,
              0,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -0.143,
                    0.257
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    -1.115
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.257,
                    -0.143
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1.115,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.143,
                    -0.257
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    1.116
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.257,
                    0.143
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1.114,
                    0.6
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    -1.115
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.143,
                    0.257
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1.115,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.257,
                    0.143
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    1.116
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.143,
                    -0.257
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1.114,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.257,
                    -0.143
                  ]
                ],
                v: [
                  [
                    -4.117,
                    -4.746
                  ],
                  [
                    -1.401,
                    -9.691
                  ],
                  [
                    1.4,
                    -9.691
                  ],
                  [
                    4.116,
                    -4.746
                  ],
                  [
                    4.745,
                    -4.116
                  ],
                  [
                    9.691,
                    -1.401
                  ],
                  [
                    9.691,
                    1.401
                  ],
                  [
                    4.745,
                    4.117
                  ],
                  [
                    4.116,
                    4.746
                  ],
                  [
                    1.4,
                    9.69
                  ],
                  [
                    -1.401,
                    9.69
                  ],
                  [
                    -4.117,
                    4.746
                  ],
                  [
                    -4.746,
                    4.117
                  ],
                  [
                    -9.692,
                    1.401
                  ],
                  [
                    -9.692,
                    -1.401
                  ],
                  [
                    -4.746,
                    -4.116
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "mm",
            mm: 4,
            nm: "패스 병합 1",
            mn: "ADBE Vector Filter - Merge",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                1,
                0.870588235294,
                0.011764705882,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "칠 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                11.056,
                11.057
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "그룹 2",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 34.9800014247646,
    op: 47.4675019333909,
    st: 34.9800014247646,
    bm: 0
  },
  {
    ddd: 0,
    ind: 7,
    ty: 4,
    nm: "star 윤곽선 10",
    parent: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          115.463,
          29.32,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          11.056,
          11.056,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 34.98,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 38.976,
            s: [
              62.997,
              62.997,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 43,
            s: [
              42.997,
              42.997,
              100
            ]
          },
          {
            t: 46.9675019130255,
            s: [
              0,
              0,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -0.095,
                    0.171
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.398,
                    -0.74
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.171,
                    -0.095
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.74,
                    -0.398
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.095,
                    -0.171
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.398,
                    0.74
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.171,
                    0.095
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.739,
                    0.398
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.398,
                    -0.74
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.095,
                    0.171
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.74,
                    0.398
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.171,
                    0.095
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.398,
                    0.74
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.095,
                    -0.171
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.739,
                    -0.398
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.171,
                    -0.095
                  ]
                ],
                v: [
                  [
                    -2.051,
                    -3.829
                  ],
                  [
                    -0.249,
                    -7.11
                  ],
                  [
                    1.609,
                    -7.11
                  ],
                  [
                    3.411,
                    -3.829
                  ],
                  [
                    3.828,
                    -3.411
                  ],
                  [
                    7.11,
                    -1.61
                  ],
                  [
                    7.11,
                    0.249
                  ],
                  [
                    3.828,
                    2.051
                  ],
                  [
                    3.411,
                    2.468
                  ],
                  [
                    1.609,
                    5.749
                  ],
                  [
                    -0.249,
                    5.749
                  ],
                  [
                    -2.051,
                    2.468
                  ],
                  [
                    -2.468,
                    2.051
                  ],
                  [
                    -5.75,
                    0.249
                  ],
                  [
                    -5.75,
                    -1.61
                  ],
                  [
                    -2.468,
                    -3.411
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "mm",
            mm: 4,
            nm: "패스 병합 1",
            mn: "ADBE Vector Filter - Merge",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                1,
                1,
                1,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "칠 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                11.056,
                11.057
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "그룹 2",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 34.9800014247646,
    op: 47.4675019333909,
    st: 34.9800014247646,
    bm: 0
  },
  {
    ddd: 0,
    ind: 8,
    ty: 4,
    nm: "star 윤곽선 9",
    parent: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          4.088,
          45.253,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          11.056,
          11.056,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 34.98,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 38.976,
            s: [
              35.994,
              35.994,
              100
            ]
          },
          {
            i: {
              x: [
                0.667,
                0.667,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 42.973,
            s: [
              15.994,
              15.994,
              100
            ]
          },
          {
            t: 46.9675019130255,
            s: [
              0,
              0,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -0.143,
                    0.257
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    -1.115
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.257,
                    -0.143
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1.115,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.143,
                    -0.257
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    1.116
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.257,
                    0.143
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1.114,
                    0.6
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    -1.115
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.143,
                    0.257
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1.115,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.257,
                    0.143
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    1.116
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.143,
                    -0.257
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1.114,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.257,
                    -0.143
                  ]
                ],
                v: [
                  [
                    -4.117,
                    -4.746
                  ],
                  [
                    -1.401,
                    -9.691
                  ],
                  [
                    1.4,
                    -9.691
                  ],
                  [
                    4.116,
                    -4.746
                  ],
                  [
                    4.745,
                    -4.116
                  ],
                  [
                    9.691,
                    -1.401
                  ],
                  [
                    9.691,
                    1.401
                  ],
                  [
                    4.745,
                    4.117
                  ],
                  [
                    4.116,
                    4.746
                  ],
                  [
                    1.4,
                    9.69
                  ],
                  [
                    -1.401,
                    9.69
                  ],
                  [
                    -4.117,
                    4.746
                  ],
                  [
                    -4.746,
                    4.117
                  ],
                  [
                    -9.692,
                    1.401
                  ],
                  [
                    -9.692,
                    -1.401
                  ],
                  [
                    -4.746,
                    -4.116
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "mm",
            mm: 4,
            nm: "패스 병합 1",
            mn: "ADBE Vector Filter - Merge",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                1,
                1,
                1,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "칠 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                11.056,
                11.057
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "그룹 2",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 34.9800014247646,
    op: 47.4675019333909,
    st: 34.9800014247646,
    bm: 0
  }
];
const markers = [];
const rightAnimation = {
  v,
  meta,
  fr,
  ip,
  op,
  w,
  h,
  nm,
  ddd,
  assets,
  layers,
  markers
};
export {
  assets,
  ddd,
  rightAnimation as default,
  fr,
  h,
  ip,
  layers,
  markers,
  meta,
  nm,
  op,
  v,
  w
};
//# sourceMappingURL=toon_outro_right.json.js.map
